// #1130: display text for a spread or total leg on the ticket, with its line.
// Single job: turn a spread/total leg into "KC -3.5" / "Over 44.5". Pure: reads the
// leg only. Returns null for any other market (the caller keeps its own text) and
// never invents a number: no usable line means the bare pick.
import { displayMarketKey } from './markets';
import { hasLineValue, isNegativeLine } from './betting';

const SPREAD_KEYS = new Set(['spread', 'nfl:spread', 'pl']);
const TOTAL_KEYS = new Set(['ou', 'nfl:total']);
const SIDE = /^(over|under)\b/i;

function fmtNumber(line) {
  return String(Number(line));
}

// A trailing line token already in the pick ("KC -3.5", a stale "KC -3", "KC PK") is
// dropped so the stored line, the one that grades, is shown once. Only a whole
// space-separated number/PK token matches, so "San Francisco 49ers" is untouched.
const TRAILING_LINE = /\s+(?:[+-]?\d+(?:\.\d+)?|PK)$/i;

function withLine(base, lineText) {
  const trimmed = String(base).trim().replace(TRAILING_LINE, '');
  return `${trimmed} ${lineText}`;
}

export function teamLegLineText(leg) {
  if (!leg) return null;
  const key = displayMarketKey(leg);

  if (SPREAD_KEYS.has(key)) {
    const pick = typeof leg.pick === 'string' ? leg.pick.trim() : '';
    if (!pick) return null;
    if (!hasLineValue(leg.line)) return pick;
    const n = Number(leg.line);
    if (n === 0) return withLine(pick, 'PK');
    return withLine(pick, n > 0 ? `+${fmtNumber(n)}` : fmtNumber(n));
  }

  if (TOTAL_KEYS.has(key)) {
    const pick = typeof leg.pick === 'string' ? leg.pick.trim() : '';
    const ou = typeof leg.overUnder === 'string' ? leg.overUnder.trim() : '';
    const sideMatch = (ou || pick).match(SIDE);
    const side = sideMatch ? sideMatch[1][0].toUpperCase() + sideMatch[1].slice(1).toLowerCase() : '';
    if (!side) return pick || null;
    // #1135: a negative total has no target; show the bare side.
    if (!hasLineValue(leg.line) || isNegativeLine(leg.line)) return side;
    return `${side} ${fmtNumber(leg.line)}`;
  }

  return null;
}
